import * as React from 'react';
import translate from '../../../../locale/translate';

import { CheckboxInput } from '../../common/Input';
import { NodeTagFilterEditor, } from '../../common/Editor';
import ISettings from './ISettings';
import { IInputChangeEventHandler } from '../../../../interfaces';
import { Tag } from '../../../../store/models';

interface IProps {
    data: { tags: Tag[] },
    settings: ISettings,
    handleChange: IInputChangeEventHandler
}

export default class Editor extends React.Component<IProps, void> {
    handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleChange(evt.target.name, evt.target.checked);
    }

    render() {
        const { settings, handleChange } = this.props;

        return (
            <div>
                <h3>{translate.gettext("Filter")}</h3>

                <NodeTagFilterEditor {...this.props} />

                <h3>{translate.gettext("Display")}</h3>

                <CheckboxInput
                    name="displayChart"
                    label={translate.gettext("Display chart")}
                    checked={settings.displayChart}
                    onChange={this.handleChange.bind(this)} />

                <CheckboxInput
                    label={translate.gettext("Display table")}
                    name="displayTable"
                    checked={settings.displayTable}
                    onChange={this.handleChange.bind(this)} />


                <h3>{translate.gettext("Columns")}</h3>

                <CheckboxInput
                    label={translate.gettext("Total alerts")}
                    name="displayAlertsTotal"
                    checked={settings.displayAlertsTotal}
                    onChange={this.handleChange.bind(this)} />

                <CheckboxInput
                    label={translate.gettext("Alerts of system")}
                    name="displayAlertsNode"
                    checked={settings.displayAlertsNode}
                    onChange={this.handleChange.bind(this)} />

                <CheckboxInput
                    label={translate.gettext("Alerts of sensors / Sensorhubs")}
                    name="displayAlertsChildren"
                    checked={settings.displayAlertsChildren}
                    onChange={this.handleChange.bind(this)} />


            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/alerts/listAlertCount/Editor.tsx